<div
  #headerBar
  id="header-container"
  class="header-container"
  [hidden]="!isShowHeader || isSharePage"
  *ngIf="isBrowser && !isSharePage"
>
@if(!isSharePage)
{
  <div class="header">
    <app-welcome-page-header
      [elementToAppend]="headerBar"
      class="top-bar"
    ></app-welcome-page-header>
  </div>
}
</div>
<app-loader *ngIf="!isSharePage"></app-loader>
<p-toast *ngIf="!isSharePage" key="main" [style]="isMobile ? 'right: 0px' : ''" styleClass="main-toast"></p-toast>
<app-auth *ngIf="isBrowser" ngSkipHydration></app-auth>
<p-dialog
  *ngIf="isBrowser"
  [(visible)]="phoneRequiredDialogVisible"
  [modal]="true"
  [blockScroll]="false"
  [dismissableMask]="false"
  [closeOnEscape]="false"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '100%', maxWidth: '430px' }"
  appendTo="body"
  styleClass="dialog bg-primary-linear"
>
  <div class="p-3">
    <ng-container *ngIf="phoneDialogStep === 'phone'; else verifyPhoneStep">
      <h2 class="title mb-2">Complete your profile</h2>
      <p class="mb-3">Add your phone number to continue using your account.</p>

      <form [formGroup]="phoneRequiredForm">
        <app-country-input
          label="Phone number*"
          placeholder="Phone number"
          [isNewControlResponse]="true"
          formControlName="contactPhone"
          [containerStyleClass]="'bordered-container-gray'"
          [inputStyleClass]="'borderless'"
          [flagDropdownStyle]="'borderless'"
          [floatLabel]="false"
        ></app-country-input>
      </form>

      <div *ngIf="phoneValidationError" class="error-sign mt-2">
        {{ phoneValidationError }}
      </div>

      <button
        pButton
        type="button"
        class="w-full mt-3"
        (click)="saveRequiredPhoneNumber()"
      >
        Send verification code
      </button>
    </ng-container>

    <ng-template #verifyPhoneStep>
      <h2 class="title mb-2">Verify your phone</h2>
      <p class="mb-3">Enter the 4-digit code we sent to you on mail.</p>

      <app-verify-form
        [messageResource]="phoneOtpResourceType"
        [errorMessage]="phoneOtpErrorMessage"
        [confirmButtonClass]="'button-simple rounded-border primary-btn sm-35 margin-centered'"
        (otpCode)="verifyRequiredPhoneOtp($event)"
        (resentOtp)="resendRequiredPhoneOtp()"
      ></app-verify-form>
    </ng-template>

    <button
      pButton
      type="button"
      class="w-full mt-2 p-button-outlined"
      [disabled]="phoneLogoutInProgress"
      (click)="logoutFromRequiredPhoneDialog()"
    >
      Log out
    </button>
  </div>
</p-dialog>
<main [ngClass]="{ 'header-margin': !isSharePage }">
  <router-outlet></router-outlet>
</main>
<div class="col-12 no-padding" *ngIf="!isSharePage">
  <app-footer [isHideFooterLinks]="signedIn"></app-footer>
</div>
<p-confirmDialog *ngIf="!isSharePage" class="{{ businessType || '' }}"></p-confirmDialog>
<app-pro-feature-modal *ngIf="isBrowser" ngSkipHydration></app-pro-feature-modal>

<div *ngIf="!isSharePage" class="offline">
  <p-toast key="offline" life="0" styleClass="main-toast"></p-toast>
</div>
